<template>
    <div class="admin-page">
        <router-view/>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.admin-page {
}
</style>
